import _indexOf from 'lodash/indexOf';

import currenciesService from "../services/currencies";

import {
    PERSONAL_SET_CURRENCY,
    CART_SHOULD_UPDATE_TOTALS
} from '../actions/actionTypes';

const currenciesMiddleware = store => next => action => {


    //Todo in the future check what currencies are coming from the server in products, etc, to get the allowed currencies that can be used
    // and liberate products component from changing the currency when a product has not the currency
    //  but for now we stick to the 3 main currencies
    //  let actions = [
    //      CART_ADD,
    //      CART_UPDATE,
    //      CART_REMOVE,
    //      CART_CLEAN,
    //      CHANGE_STEP
    //  ];
    //
    //  let shouldAct = _.findIndex(actions, function (o) {
    //      return o === action.type;
    //  });
    //
    //  if (shouldAct >= 0) {
    //
    //  }


    if (action.type === PERSONAL_SET_CURRENCY) {

        const currency = action.payload;

        const is_allowed = _indexOf(currenciesService.defaultCurrencies, currency);

        if (is_allowed !== -1){
            next(action);
            store.dispatch({type: CART_SHOULD_UPDATE_TOTALS});
        }else{
            action.payload = 'GBP';
            next(action);
            store.dispatch({type: CART_SHOULD_UPDATE_TOTALS});
        }
    }else{
        next(action);
    }


};

export default currenciesMiddleware
